<template>
  <section class="architecture">
    <div class="container arch-layout">
      <h2 class="arch-title">技术<br>架构</h2>

      <div class="arch-stack">
        <!-- 客户端层 -->
        <div class="arch-layer">
          <div class="arch-layer-label">客户端层 <div class="arch-connector">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="48" viewBox="0 0 15 48" fill="none">
                <path
                  d="M8.36401 1V0H6.36401V1H7.36401H8.36401ZM6.65691 47.7071C7.04743 48.0976 7.6806 48.0976 8.07112 47.7071L14.4351 41.3431C14.8256 40.9526 14.8256 40.3195 14.4351 39.9289C14.0446 39.5384 13.4114 39.5384 13.0209 39.9289L7.36401 45.5858L1.70716 39.9289C1.31664 39.5384 0.68347 39.5384 0.292946 39.9289C-0.0975785 40.3195 -0.0975785 40.9526 0.292946 41.3431L6.65691 47.7071ZM7.36401 1H6.36401V47H7.36401H8.36401V1H7.36401Z"
                  fill="url(#paint0_linear_854_377)" />
                <defs>
                  <linearGradient id="paint0_linear_854_377" x1="7.86401" y1="1" x2="7.86401" y2="47"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#666666" stop-opacity="0" />
                    <stop offset="1" stop-color="#666666" />
                  </linearGradient>
                </defs>
              </svg>
              <span class="arch-connector-label">HTTPS/WebRTC</span>

            </div>
          </div>
          <div class="arch-nodes arch-nodes--client">
            <div v-for="n in clientNodes" :key="n" class="arch-node">{{ n }}</div>
          </div>

        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2" viewBox="0 0 710 2" fill="none">
          <path d="M0.000488281 0.5L710 1.18105" stroke="url(#paint0_linear_819_703)" />
          <defs>
            <linearGradient id="paint0_linear_819_703" x1="710" y1="1.68105" x2="8.67099e-06" y2="1"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#393939" stop-opacity="0" />
              <stop offset="0.153846" stop-color="#6C6C6C" stop-opacity="0.5" />
              <stop offset="0.846154" stop-color="#6C6C6C" stop-opacity="0.5" />
              <stop offset="1" stop-color="#393939" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>


        <!-- 边缘接入层 -->
        <div class="arch-layer">
          <div class="arch-layer-label">边缘接入层

          </div>
          <div class="arch-nodes">
            <div v-for="n in edgeNodes" :key="n" class="arch-node">{{ n }}</div>
          </div>
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2" viewBox="0 0 710 2" fill="none">
          <path d="M0.000488281 0.5L710 1.18105" stroke="url(#paint0_linear_819_703)" />
          <defs>
            <linearGradient id="paint0_linear_819_703" x1="710" y1="1.68105" x2="8.67099e-06" y2="1"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#393939" stop-opacity="0" />
              <stop offset="0.153846" stop-color="#6C6C6C" stop-opacity="0.5" />
              <stop offset="0.846154" stop-color="#6C6C6C" stop-opacity="0.5" />
              <stop offset="1" stop-color="#393939" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>


        <!-- 渲染计算层 -->
        <div class="arch-layer arch-layer--panel">
          <div class="arch-layer-label">渲染计算层
            <div class="arch-connector arch-connector--panel">


              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="48" viewBox="0 0 15 48" fill="none">
                <path
                  d="M8.36401 1V0H6.36401V1H7.36401H8.36401ZM6.65691 47.7071C7.04743 48.0976 7.6806 48.0976 8.07112 47.7071L14.4351 41.3431C14.8256 40.9526 14.8256 40.3195 14.4351 39.9289C14.0446 39.5384 13.4114 39.5384 13.0209 39.9289L7.36401 45.5858L1.70716 39.9289C1.31664 39.5384 0.68347 39.5384 0.292946 39.9289C-0.0975785 40.3195 -0.0975785 40.9526 0.292946 41.3431L6.65691 47.7071ZM7.36401 1H6.36401V47H7.36401H8.36401V1H7.36401Z"
                  fill="url(#paint0_linear_854_377)" />
                <defs>
                  <linearGradient id="paint0_linear_854_377" x1="7.86401" y1="1" x2="7.86401" y2="47"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="#666666" stop-opacity="0" />
                    <stop offset="1" stop-color="#666666" />
                  </linearGradient>
                </defs>

              </svg>
              <span class="arch-connector-label">内网高速互联</span>
            </div>
          </div>
          <div class="arch-layer-body">
            <div class="arch-nodes">
              <div v-for="n in renderNodes" :key="n" class="arch-node">{{ n }}</div>
            </div>
            <div class="arch-nodes arch-nodes--pair">
              <div v-for="n in renderMeta" :key="n" class="arch-node arch-node--wide">{{ n }}</div>
            </div>
          </div>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2" viewBox="0 0 710 2" fill="none">
          <path d="M0.000488281 0.5L710 1.18105" stroke="url(#paint0_linear_819_703)" />
          <defs>
            <linearGradient id="paint0_linear_819_703" x1="710" y1="1.68105" x2="8.67099e-06" y2="1"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#393939" stop-opacity="0" />
              <stop offset="0.153846" stop-color="#6C6C6C" stop-opacity="0.5" />
              <stop offset="0.846154" stop-color="#6C6C6C" stop-opacity="0.5" />
              <stop offset="1" stop-color="#393939" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>

        <!-- 资源调度层 -->
        <div class="arch-layer arch-layer--panel">
          <div class="arch-layer-label">资源调度层</div>
          <div class="arch-layer-body">
            <div class="arch-nodes">
              <div v-for="n in scheduleNodes" :key="n" class="arch-node">{{ n }}</div>
            </div>
            <div class="arch-nodes arch-nodes--pair">
              <div v-for="n in scheduleMeta" :key="n" class="arch-node arch-node--wide">{{ n }}</div>
            </div>
          </div>
        </div>

        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="2" viewBox="0 0 710 2" fill="none">
          <path d="M0.000488281 0.5L710 1.18105" stroke="url(#paint0_linear_819_703)" />
          <defs>
            <linearGradient id="paint0_linear_819_703" x1="710" y1="1.68105" x2="8.67099e-06" y2="1"
              gradientUnits="userSpaceOnUse">
              <stop stop-color="#393939" stop-opacity="0" />
              <stop offset="0.153846" stop-color="#6C6C6C" stop-opacity="0.5" />
              <stop offset="0.846154" stop-color="#6C6C6C" stop-opacity="0.5" />
              <stop offset="1" stop-color="#393939" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
        <!-- 业务支撑层 -->
        <div class="arch-layer">
          <div class="arch-layer-label">业务支撑层</div>
          <div class="arch-nodes">
            <div v-for="n in businessNodes" :key="n" class="arch-node">{{ n }}</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const clientNodes = ['Web Browser', 'iOS App', 'Android App', 'Smart TV', 'Win / Linux'];
const edgeNodes = ['智能路由', '负载均衡', '会话管理', 'CDN 加速'];
const renderNodes = ['GPU 渲染集群', '视频编码', '音频处理', '输入转发'];
const renderMeta = ['NVidia /amd /国产GPU', 'H264/H265/AV1/VP9硬件编码'];
const scheduleNodes = ['容器编排', '资源池化', '弹性伸缩', '监控告警'];
const scheduleMeta = ['Kubernetes + 自研调度器', 'Prometheus + Grafana'];
const businessNodes = ['用户认证', '计费系统', '数据分析', '运营后台'];
</script>

<style scoped lang="scss">
.architecture {
  padding: 80px 0 100px;
}

.arch-layout {
  display: flex;
  align-items: center;
  gap: 48px;
}

.arch-title {
  flex: 0 0 auto;
  margin: 0;
  text-orientation: upright;
  color: #fff;
  font-family: "Noto Sans SC", sans-serif;
  font-size: clamp(36px, 4vw, 64px);
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 5.12px;
  width: 300px;
}

.arch-stack {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.arch-layer {
  display: grid;
  grid-template-columns: 1fr 2fr;
  gap: 16px;
  align-items: center;
  position: relative;
}

.arch-layer-label {
  text-orientation: upright;
  letter-spacing: 0.2em;
  color: #EFEFEF;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  justify-self: start;
  text-align: left;
  position: relative;
}

.arch-layer-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.arch-nodes {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}

.arch-nodes--client {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.arch-nodes--pair {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.arch-node {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 12px ;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 1.35;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: linear-gradient(116deg, rgba(255, 255, 255, 0.11) 4.21%, rgba(255, 255, 255, 0.00) 101.7%);
}

.arch-connector {
  display: flex;
  align-items: center;
  gap: 6px;
  color: rgba(255, 255, 255, 0.55);
  font-size: 13px;
  position: absolute;
  top: 154%;
  left: 11px;
  transform-origin: 50% 0;
  width: 200px;
}

.arch-connector--panel {
  top: -600%;
}

.arch-connector-line {
  width: 1px;
  height: 18px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0.55));
}

.arch-connector-arrow {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 7px solid rgba(255, 255, 255, 0.55);
}

.arch-divider {
  height: 1px;
  margin-left: 44px;
  background: rgba(239, 239, 239, 0.18);
}

@media (max-width: 900px) {
  .arch-layout {
    flex-direction: column;
    align-items: stretch;
    gap: 32px;
  }

  .arch-title {
    writing-mode: horizontal-tb;
    text-orientation: mixed;
    letter-spacing: 0.12em;
    text-align: center;
    font-size: clamp(28px, 6vw, 40px);
  }

  .arch-layer {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .arch-layer-label {
    writing-mode: horizontal-tb;
    text-orientation: mixed;
    letter-spacing: 0.08em;
    justify-self: start;
    font-size: 15px;
  }

  .arch-connector,
  .arch-divider {
    margin-left: 0;
  }
}

@media (max-width: 640px) {
  .arch-nodes {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .arch-nodes--pair {
    grid-template-columns: 1fr;
  }

  .arch-node {
    min-height: 44px;
    font-size: 13px;
  }
}
</style>
